module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-project-types-for-responsibles"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: _vm.selectedRow ? 'col-lg-3' : 'col-lg-6'
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Opgavetyper\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder fit-content"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'total_revenue') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.total_revenue)) + "\n                            ")]) : (props.column.field == 'total_coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.total_coverage)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 1445950624)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data. Husk at angive i indstillingerne hvilke medarbejdere, der skal listes her\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: _vm.selectedRow ? 'col-lg-9' : 'col-lg-6'
  }, [(!_vm.selectedRow) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n                Vælg en opgavetype for at se et overblik over de enkelte ansvarlige her\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedRow = null
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('project-types-responsibles', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6b20ccd5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b20ccd5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsibles/learning/compareProjectTypesForResponsibles.vue
// module id = 852
// module chunks = 0